import {
  CREATING_SETTING,
  UPDATING_SETTING,
  SETTING_CREATED,
  SETTING_UPDATED,
  ERROR_SETTING_CREATE,
  UPDATED_RECENTLY,
  SET_UPDATED_RECENTLY_TO_FALSE
} from "./types";
import axios from "axios";
import { BASE_URL } from "../urls";
import { message } from "antd";

export const setUpdatedRecentlyToFalse = () => async (dispatch) => {
  dispatch({
    type: SET_UPDATED_RECENTLY_TO_FALSE,
  });
}

export const createEntity = (formData, tokenData, exitNow, history) => async (dispatch) => {
  dispatch({
    type: CREATING_SETTING,
  });

  let webKitFormData = new FormData();
  Object.keys(formData).forEach((item, i) => {
    webKitFormData.append(item, formData[item])
  });

  await axios
    .post(`${BASE_URL}api/v1/admin/global/add`, webKitFormData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        'Authorization': `${tokenData.token_type} ${tokenData.access_token}`
      }
    })
    .then(function (response) {
      dispatch({
        type: SETTING_CREATED,
        payload: response,
      });
      dispatch({
        type: UPDATED_RECENTLY,
      })
      message.success(response.data.message);
      
      if (exitNow) {
        history.push("/settings")
      }
    })
    .catch(function (error) {
      dispatch({
        type: ERROR_SETTING_CREATE,
        payload: error.response,
      })      
      message.error(error.response.data.message);
    });
};

export const updateEntityInfo = (formData, tokenData, id) => async (dispatch) => {
  dispatch({
    type: UPDATING_SETTING,
  });

  let webKitFormData = new FormData();

  Object.keys(formData).forEach((item, i) => {
    webKitFormData.append(item, formData[item])
  });  
  webKitFormData.append('_method', 'put')

  await axios
    .post(`${BASE_URL}api/v1/admin/global/edit/${id}`, webKitFormData, {
      headers: {
        'Authorization': `${tokenData.token_type} ${tokenData.access_token}`
      }
    })
    .then(function (response) {
      dispatch({
        type: SETTING_UPDATED,
        payload: response,
      });
      dispatch({
        type: UPDATED_RECENTLY,
      })      
      message.success(response.data.message);
    })
    .catch(function (error) {
      dispatch({
        type: ERROR_SETTING_CREATE,
        payload: error.response,
      })   
      message.error(error.response.data.message);
    });
};
